import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ColComponent, FormModule, RowComponent } from '@coreui/angular-pro';
import { IQueryFilterRange } from '../../models/vehicle-status.model';
import { CommonModule } from '@angular/common';

interface RangeFilterOption {
  value: IQueryFilterRange
  label: string;
}


@Component({
  selector: 'app-range-filter',
  standalone: true,
  imports: [
    RowComponent,
    ColComponent,
    FormsModule,
    FormModule,
    CommonModule
  ],
  templateUrl: './range-filter.component.html',
  styleUrl: './range-filter.component.scss'
})
export class RangeFilterComponent {

  @Input() model: any;
  @Output() modelChange = new EventEmitter()

  @Input() options: RangeFilterOption[] = [
    { value: IQueryFilterRange.ThisYear, label: "This Year" },
    { value: IQueryFilterRange.ThisMonth, label: "This Month" },
    { value: IQueryFilterRange.PrevMonth, label: "Previous Month" }
  ];
  @Input() title!: string;


}
